import Button from "./Button";
import SubmitButton from "./SubmitButton";
export { SubmitButton };

export default Button;
